var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoveSheep(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 699.84 466.56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#a7cbc1;}.cls-2{fill:#cc3636;stroke-width:3.13px;}.cls-2,.cls-3{stroke:#060910;stroke-miterlimit:10;}.cls-4,.cls-3{fill:#dfefe9;}.cls-5{fill:#5a9b5f;}.cls-3{stroke-linecap:round;stroke-width:4.25px;}.cls-6{fill:#060910;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 699.84,
    height: 466.56
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m699.84,333.97v132.53H0v-136.52c3.61-1.19,7.23-2.34,10.87-3.43.01,0,.02-.01.02-.01,2.37-.72,4.75-1.41,7.14-2.09,60.01-16.95,122.83-19.9,185.31-21.33,7.08-.17,14.15-.31,21.22-.45,69.92-1.4,139.89-2.8,209.77-.16,12.06.46,24.13,1.03,36.19,1.74.05,0,.11.01.16.01,76.92,4.5,153.72,14.15,229.16,29.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m500.3,303.85c-9.23-.76-18.55-1.47-27.71-2.1h-.04l-.21-.02c-78.58-5.42-158.26-6.34-236.82-2.76l-1.93.09c-10.62.49-21.6.99-32.49,1.55-64.16,3.24-132.27,8.33-195.68,23.48l-.63.15h0c-1.61.4-3.22.79-4.79,1.18v5.18c2.06-.51,4.17-1.03,6.3-1.54h.68l.24-.22c62.83-14.94,130.43-19.98,194.14-23.2,10.87-.56,21.84-1.06,32.45-1.55l1.94-.08c78.4-3.58,157.91-2.66,236.33,2.75h.05l.2.02c9.1.63,18.37,1.33,27.55,2.09,74.76,6.17,140.23,14.9,199.96,26.69v-5.14c-59.66-11.71-125-20.42-199.54-26.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m362.35,227.69c-2.07,4.53-7.2,9.06-9.16,9.06s-7.09-4.53-9.16-9.06c-2.52-5.5-1.57-11.33,2.11-13.01,2.15-.98,4.75.63,7.05,2.43,2.3-1.8,4.9-3.41,7.05-2.43,3.68,1.68,4.62,7.51,2.11,13.01Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 230.77,
    y: 288.82,
    width: 9.71,
    height: 48.11,
    rx: 2.7,
    ry: 2.7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 243.07,
    y: 286.23,
    width: 9.71,
    height: 48.11,
    rx: 2.7,
    ry: 2.7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 279.42,
    y: 289.14,
    width: 9.71,
    height: 48.11,
    rx: 2.7,
    ry: 2.7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 294.3,
    y: 287.41,
    width: 9.71,
    height: 48.11,
    rx: 2.7,
    ry: 2.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m325.03,276.2c-.09-1.74-.39-3.45-.87-5.12.88-2.23,1.37-4.64,1.37-7.18,0-10.84-8.79-19.62-19.62-19.62-1.17,0-2.31.12-3.43.32-1.39-9.47-9.53-16.75-19.39-16.75-7.1,0-13.3,3.79-16.75,9.44-2.87-1.64-6.18-2.59-9.72-2.59-8.19,0-15.2,5.02-18.14,12.15-2.41-1.06-5.07-1.65-7.87-1.65-10.84,0-19.62,8.79-19.62,19.62,0,4.5,1.53,8.63,4.07,11.93-5.71,3.43-9.55,9.67-9.55,16.82,0,10.84,8.79,19.62,19.62,19.62,4.62,0,8.86-1.61,12.21-4.28,3.26,6.33,9.84,10.67,17.45,10.67,6.38,0,12.02-3.05,15.61-7.76.12,0,.24,0,.36,0,.97,0,1.93-.02,2.89-.05,3.41,2.87,7.81,4.61,12.63,4.61,7.33,0,13.71-4.03,17.08-9.98,1.82.55,3.74.86,5.74.86,10.84,0,19.62-8.79,19.62-19.62,0-4.27-1.38-8.21-3.7-11.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m266.34,237.29s-3.33,6.76-1.73,11.33"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m258.06,264.01s5.82,13.27,24.27,8.09"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m223.76,282.13s-9.06,11.33.97,22"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m292.89,298.46s14.41,1.63,18.1-12.55"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-6",
    cx: 313.04,
    cy: 249.77,
    rx: 13.5,
    ry: 17.83,
    transform: "translate(-54.02 89.62) rotate(-15.01)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-6",
    cx: 298.22,
    cy: 246.06,
    rx: 6.02,
    ry: 2.65,
    transform: "translate(-80.07 325.95) rotate(-51.45)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-6",
    cx: 318.64,
    cy: 235.18,
    rx: 2.74,
    ry: 5.82,
    transform: "translate(46.9 523.28) rotate(-83.11)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 308.88,
    cy: 248.22,
    r: 1.19
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 322.18,
    cy: 243.43,
    r: 1.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 393.3,
    y: 328.74,
    width: 8.34,
    height: 41.32,
    rx: 2.05,
    ry: 2.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 403.86,
    y: 326.51,
    width: 8.34,
    height: 41.32,
    rx: 2.05,
    ry: 2.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 437.67,
    y: 327.9,
    width: 8.34,
    height: 41.32,
    rx: 2.05,
    ry: 2.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 450.83,
    y: 328.64,
    width: 8.34,
    height: 41.32,
    rx: 2.05,
    ry: 2.05
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m484.92,308.91c0-8.73-5.57-16.14-13.35-18.92-2.52-7.06-8.86-12.29-16.54-13.2-2.53-8.21-10.18-14.19-19.22-14.19-5.27,0-10.04,2.04-13.63,5.35-2.42-1.03-5.09-1.61-7.89-1.61-5.38,0-10.26,2.13-13.87,5.57-3.15-2.04-6.89-3.24-10.92-3.24-11.11,0-20.11,9-20.11,20.11,0,3.2.76,6.2,2.09,8.89-.19.3-.37.6-.54.9-5.96,3.49-9.97,9.94-9.97,17.34,0,10.85,8.59,19.66,19.34,20.07,2.71,7.91,10.19,13.6,19.02,13.6,4.9,0,9.39-1.76,12.88-4.67.65.07,1.31.13,1.97.18,3.47,6.03,9.97,10.1,17.43,10.1,5.7,0,10.83-2.38,14.49-6.18,1.51.36,3.07.57,4.69.57,11.11,0,20.11-9,20.11-20.11,0-.47-.04-.92-.07-1.38,8.17-2.56,14.1-10.18,14.1-19.2Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-6",
    cx: 481.96,
    cy: 315.58,
    rx: 3.2,
    ry: 7.64,
    transform: "translate(-93.04 350.97) rotate(-36.74)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-6",
    cx: 364.68,
    cy: 295.94,
    rx: 18.16,
    ry: 12.04,
    transform: "translate(-104.01 325.99) rotate(-42.73)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-6",
    cx: 381.12,
    cy: 296.64,
    rx: 2.78,
    ry: 7.23,
    transform: "translate(-100.73 329.32) rotate(-41.77)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 365.23,
    cy: 292.51,
    r: 1.02
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m449.59,294.66s-10.61,4.17-8.27,15.44"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m395.25,323.36s10.01,14.45,21.86,1.11"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m416.74,300.94s3.98-8.71-5.19-14.82"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m455.03,276.79s-6.52-1.51-10.69,2.66"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m447.87,349.12s-9.45-2.78-10.01-10.56"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoveSheep);
export default __webpack_public_path__ + "static/media/love_sheep.51014d1b0fa87d6c14ab213af85409fe.svg";
export { ForwardRef as ReactComponent };